module.exports = __webpack_public_path__ + "static/media/Fernando Plaza.8ad331d9.jpg";